var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    { attrs: { label: _vm.label } },
    [
      _c(
        "v-select",
        {
          class: { "v-select-danger": _vm.danger, "select-size-sm": _vm.small },
          attrs: {
            name: _vm.name,
            value: _vm.optionSelected,
            options: _vm.institutionsState.list,
            disabled: _vm.isDisabled
          },
          on: { input: _vm.onInput },
          scopedSlots: _vm._u([
            {
              key: "spinner",
              fn: function() {
                return [
                  _vm.institutionsState.loading
                    ? _c("b-spinner", {
                        style: {
                          opacity: _vm.institutionsState.loading ? 1 : 0
                        },
                        attrs: { small: "", variant: "primary" }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v(" no hay instituciones para el criterio de búsqueda ")
          ])
        ],
        2
      ),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to",
              staticStyle: { height: "19px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.dangerText) + " ")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }